import React from 'react';
import { useNavigate } from 'react-router';

import { RoutingViews, routingPaths } from '@core/services/routingService';
import DemmiButton, { DemmiButtonSize } from '@demmi-ui/Button';
import { navigateTransitioned } from '@helpers/app.helper';

import DashboardSection from '../DashboardSection';

interface Props {
  isLoading: boolean;
}

const WidgetAnalytics: React.FC<Props> = () => {
  const CSSBlock = 'widget-analytics';

  const navigate = useNavigate();

  return (
    <DashboardSection
      className={CSSBlock}
      title="Analytics"
      titleButton={
        <DemmiButton
          text="Show More"
          size={DemmiButtonSize.S}
          onClick={() => {
            navigateTransitioned({
              navigate,
              to: routingPaths[RoutingViews.ANALYTICS],
            });
          }}
        />
      }>
      <div className={`${CSSBlock}__coming-soon`}>Coming Soon</div>
    </DashboardSection>
  );
};

export default WidgetAnalytics;
